import React, { MutableRefObject, useRef, useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import * as M from "moment";
import { Dropdown, Radio, Space, Spin } from "antd";
import { debounce } from "lodash";

import "ol/ol.css";
import { Overlay } from "ol";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import WMTS, { optionsFromCapabilities } from "ol/source/WMTS";
import WMTSCapabilities from "ol/format/WMTSCapabilities";
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import Projection from "ol/proj/Projection";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Chart from "ol-ext/style/Chart";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import VectorSource from "ol/source/Vector";
import { KML } from "ol/format";
import VectorLayer from "ol/layer/Vector";
import { transform } from "ol/proj";
import CircleStyle from "ol/style/Circle";
import { Fill, Icon, Stroke, Style, Text } from "ol/style";
import Cluster from "ol/source/Cluster";
import Zoom from "ol/control/Zoom";
import { OSM } from "ol/source";

import ElectricSupply from "../../../../assets/img/ElectricSupply.png";
import ElectricSupplySelect from "../../../../assets/img/ElectricSupplySelect.png";
import gasSupply from "../../../../assets/img/gasSupply.png";
import gasSupplySelect from "../../../../assets/img/gasSupplySelect.png";
import heatSupply from "../../../../assets/img/heatSupply.png";
import heatSupplySelect from "../../../../assets/img/heatSupplySelect.png";
import lightSupply from "../../../../assets/img/lightSupply.png";
import lightSupplySelect from "../../../../assets/img/lightSupplySelect.png";
import waterSupply from "../../../../assets/img/waterSupply.png";
import waterSupplySelect from "../../../../assets/img/waterSupplySelect.png";
import drainage from "../../../../assets/img/drainage.png";
import drainageSelect from "../../../../assets/img/drainageSelect.png";
import { BASE_MAP, BM_MSK_GRAY, ORTOPHOTO_2016 } from "./TileUrl";
import { MapControlIco } from "../../../../assets/customIcons";
import DefectRegister from "../../../../store/defectRegister";
import Districts from "../../../../store/Districts";
import Constants from "../../../../constants/Common";
import Search from "./search";

import styles from "./Map.module.scss";
import "./index.scss";
interface IProps {
  refPosition: MutableRefObject<[number, number[]]>;
}

const Map2: React.FC<IProps> = observer(({ refPosition }) => {
  const openCardBtn = React.useRef(null);
  const popupRef = React.useRef(null);
  const [urlMap, setUrlMap] = React.useState(BASE_MAP);
  const notiesId = React.useRef(null);
  const [mapOsm, setMapOsm] = React.useState("BASE_MAP");
  const mapRef = useRef("");

  const handlerSelectMap = (e) => {
    window.document
      .querySelectorAll(".ol-viewport")
      .forEach((item) => item.remove());
    window.document
      .querySelectorAll(".ol-zoom.ol-unselectable.ol-control")
      .forEach((item) => item.remove());
    switch (e.target.value) {
      case "default":
        setMapOsm("default");
        break;
      case "BASE_MAP":
        setMapOsm("BASE_MAP");
        setUrlMap(BASE_MAP);
        break;
      case "BM_MSK_GRAY":
        setMapOsm("BM_MSK_GRAY");
        setUrlMap(BM_MSK_GRAY);
        break;
      case "ORTOPHOTO_2016":
        setMapOsm("ORTOPHOTO_2016");
        setUrlMap(ORTOPHOTO_2016);
        break;
      default:
        return;
    }
  };

  const onAddressSearch = (e) => {
    DefectRegister.initialFilter.Address =
      e.target.value !== "" ? e.target.value : null;
    debouncedSearchForm();
  };

  const debouncedSearchForm = useCallback(
    debounce(() => DefectRegister.getRegistry(), 500),
    [],
  );

  if (toJS(DefectRegister.registryList).items) {
    window.document
      .querySelectorAll(".ol-viewport")
      .forEach((item) => item.remove());
    const parser = new WMTSCapabilities();
    proj4.defs(
      "EPSG:202474",
      // "EPSG:4326",
      "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=95942.17 +y_0=-6552810 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs",
    );
    register(proj4);

    const projection = new Projection({
      code: "202474",
      extent: [-200000.0, -200000.0, 450000.0, 300000.0],
    });
    const markersStyle = [
      "",
      heatSupply,
      waterSupply,
      gasSupply,
      lightSupply,
      drainage,
      ElectricSupply,
    ];
    const markersStyleSelected = [
      "",
      heatSupplySelect,
      waterSupplySelect,
      gasSupplySelect,
      lightSupplySelect,
      drainageSelect,
      ElectricSupplySelect,
    ];
    let map;

    const loadMarkers = (tileLayers: Array<TileLayer<OSM | WMTS>>) => {
      const arrayMarkers = toJS(DefectRegister.registryList).items;
      let markersArray = [];
      for (let i = 0; i < arrayMarkers?.length; i++) {
        if (arrayMarkers[i].lat && arrayMarkers[i].lng) {
          markersArray.push(arrayMarkers[i]);
        }
        if (arrayMarkers[i].addressDisconnexionList?.length > 0) {
          markersArray = [
            ...markersArray,
            ...arrayMarkers[i].addressDisconnexionList.map(
              ({ lon: lng, ...address }) => {
                return {
                  ...address,
                  lng,
                };
              },
            ),
          ];
        }
      }
      const marker = markersArray.map((point) => {
        const feature = new Feature({
          geometry: new Point(
            transform(
              // lng lat
              [point.lng, point.lat],
              //"EPSG:202474",
              "EPSG:4326",
              "EPSG:3857",
            ),
          ),
          name: point,
        });
        return feature;
      });
      const arrayId = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
      ];
      const getGridArrId = markersArray.map((item) => {
        return item.gridTypeId;
      });
      const gridArrId = getGridArrId.filter((item, pos) => {
        return getGridArrId.indexOf(item) == pos;
      });

      const view = new View({
        center: [refPosition.current[1][0], refPosition.current[1][1]],
        zoom: refPosition.current[0],
        minZoom: 9,
        padding: [0, 0, 0, 0],
      });

      const source = new VectorSource({
        features: marker?.sort(
          (a, b) => a.get("name").districtId - b.get("name").districtId,
        ),
      });

      let selected = false;
      let selectedId = null;
      let selectedCluster = true;
      const radiusArr = [];
      let size = null;
      let maxCountCluster = null;

      const styleCluster = (feature) => {
        const features = feature.get("features");
        const selectedFeature = features.filter(
          (f) => f.get("name")?.id == selectedId,
        );
        size = features.length;
        if (view.getZoom() === refPosition.current[0]) {
          radiusArr.push(size);
        }

        const radiusArrUniq = radiusArr.filter((item, pos) => {
          return radiusArr.indexOf(item) == pos;
        });
        maxCountCluster = Math.max(...radiusArrUniq);
        let gridTypeId = null;
        const colorsIdx = [
          "",
          "#FFB405",
          "#80DEEA",
          "#64B5F6",
          "#DAF567",
          "#9013FE",
          "#7ED321",
        ];

        const clusterGridTypeIdArray = feature?.values_?.features.map(
          (item) => {
            return item?.values_?.name;
          },
        );

        clusterGridTypeIdArray.forEach((item) => {
          gridTypeId = item?.gridType?.id;
        });

        // const addressArr = features.map(function (item) {
        //   return item.values_.name?.addressText;
        // });

        const gridArr = features.map(function (item) {
          return item.values_.name?.gridType?.id;
        });

        const dangers = feature?.values_?.features.filter(
          (item) => item.values_.name?.overBuildings >= 20,
        );
        const admiraltyskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 1,
        );
        const vasileOstrovskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 2,
        );
        const viborg = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 3,
        );
        const kalininskyi = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 4,
        );
        const kirovskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 5,
        );
        const kolpinskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 6,
        );
        const krasnogvard = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 7,
        );
        const krasnoselsk = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 8,
        );
        const kronshtadskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 9,
        );
        const kyrortniy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 10,
        );
        const moskovciy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 11,
        );
        const nevskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 12,
        );
        const petrogradskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 13,
        );
        const petrodvorcoviy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 14,
        );
        const primorskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 15,
        );
        const pushkinskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 16,
        );
        const frynzenskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 17,
        );
        const centralniy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 18,
        );
        const gatchinskiy = feature?.values_?.features.filter(
          (item) => item.values_.name?.districtId == 19,
        );

        const isDuplicate = features?.every(
          (val, i, arr) =>
            val.get("name").lat === arr[0].get("name").lat &&
            val.get("name").lng === arr[0].get("name").lng,
        );

        const isDuplicateTypeGrid = gridArr.every(
          (val, i, arr) => val === arr[0],
        );

        const dataP = [0, 0, 0, 0, 0, 0, 0];
        for (let i = 0, f; (f = features[i]); i++)
          dataP[f?.values_?.name?.gridType?.id]++;

        const styleCharts = () => {
          return new Style({
            zIndex: 20,
            geometry: function (f) {
              if (viborg.length && view.getZoom() <= 9.9) {
                return new Point([3370535.815049998, 8418037.146397416]);
              } else if (view.getZoom() > 9.9) {
                return new Point([
                  f?.values_?.geometry.flatCoordinates[0],
                  f?.values_?.geometry.flatCoordinates[1],
                ]);
              }
              if (admiraltyskiy.length && view.getZoom() <= 9.9) {
                return new Point([3373281.1916888743, 8381562.605837356]);
              } else if (view.getZoom() > 9.9) {
                return new Point([
                  f?.values_?.geometry.flatCoordinates[0],
                  f?.values_?.geometry.flatCoordinates[1],
                ]);
              }
              if (vasileOstrovskiy.length && view.getZoom() <= 9.9) {
                return new Point([3366921.5695579685, 8386123.398053212]);
              } else if (view.getZoom() > 9.9) {
                return new Point([
                  f?.values_?.geometry.flatCoordinates[0],
                  f?.values_?.geometry.flatCoordinates[1],
                ]);
              }
              //
              if (kalininskyi.length && view.getZoom() <= 9.9) {
                return new Point([3384548.179006989, 8400569.120592132]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (kirovskiy.length && view.getZoom() <= 9.9) {
                return new Point([3367885.5589317414, 8372502.16628506]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (kolpinskiy.length && view.getZoom() <= 9.9) {
                return new Point([3404470.1889604987, 8352153.047693586]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (krasnogvard.length && view.getZoom() <= 9.9) {
                return new Point([3392217.980745736, 8392788.635314113]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (krasnoselsk.length && view.getZoom() <= 9.9) {
                return new Point([3352090.7304182122, 8350992.8005018495]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (kronshtadskiy.length && view.getZoom() <= 9.9) {
                return new Point([3309850.183707574, 8401747.938395716]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (kyrortniy.length && view.getZoom() <= 9.9) {
                return new Point([3339459.612026484, 8420476.181242323]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (moskovciy.length && view.getZoom() <= 9.9) {
                return new Point([3374630.9005526057, 8361655.631628596]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              //
              if (nevskiy.length && view.getZoom() <= 9.9) {
                return new Point([3391149.9501075097, 8376550.137021781]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (petrogradskiy.length && view.getZoom() <= 9.9) {
                return new Point([3371584.507545299, 8392276.279979106]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (petrodvorcoviy.length && view.getZoom() <= 9.9) {
                return new Point([3329335.9600036712, 8372217.095642112]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (primorskiy.length && view.getZoom() <= 9.9) {
                return new Point([3361028.732149479, 8404714.24834496]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (pushkinskiy.length && view.getZoom() <= 9.9) {
                return new Point([3385564.1708000004, 8346308.393666257]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (frynzenskiy.length && view.getZoom() <= 9.9) {
                return new Point([3382887.589016477, 8370095.86867311]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (centralniy.length && view.getZoom() <= 9.9) {
                return new Point([3379104.8608311703, 8385360.528105736]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
              if (gatchinskiy.length && view.getZoom() <= 9.9) {
                return new Point([3357719.5183196473, 8272413.667063841]);
              } else if (view.getZoom() > 9.9) {
                return new Point(
                  // lng lat
                  [
                    f?.values_?.geometry.flatCoordinates[0],
                    f?.values_?.geometry.flatCoordinates[1],
                  ],
                );
              }
            },
            image: new Chart({
              type: "donut",
              colors: colorsIdx,
              radius: maxCountCluster === size ? 30 : 20,
              data: dataP,
              stroke: new Stroke({
                color: dangers.length ? "red" : "#fff",
                width: 1,
              }),
            }),
            text: new Text({
              stroke: new Stroke({
                color: "#FFF",
                width: 4,
              }),
              fill: new Fill({
                color: "black",
              }),
              text: size.toString(),
              font: "14px bold Calibri,sans-serif",
              offsetY: 1,
            }),
          });
        };

        // Если нет gridTypeId, то это отключенные адреса
        if (size > 1 && view.getZoom() <= 11 && !gridTypeId) {
          return new Style();
        }
        if (size > 1 && view.getZoom() <= 9.9 && gridTypeId) {
          return styleCharts();
        }
        if (size > 1 && view.getZoom() > 11 && !gridTypeId) {
          return new Style({
            zIndex: 2,
            image: new CircleStyle({
              radius: Math.min(size + 12, 18),
              stroke: new Stroke({
                width: 2,
                color: "red",
              }),
              fill: new Fill({
                color: "red",
              }),
            }),
            text: new Text({
              stroke: new Stroke({
                color: "#FFF",
                width: 4,
              }),
              fill: new Fill({
                color: "black",
              }),
              text: size.toString(),
              font: "12px bold Calibri,sans-serif",
              offsetY: 1,
            }),
          });
        }
        if (size == 1) {
          if (gridTypeId) {
            if (view.getZoom() <= 9.9) {
              return styleCharts();
            } else if (
              view.getZoom() > 9.9 &&
              selectedCluster &&
              selected &&
              selectedFeature.length &&
              selectedId
            ) {
              return new Style({
                image: new Icon({
                  src: markersStyleSelected[gridTypeId],
                }),
              });
            } else if (view.getZoom() > 9.9) {
              return new Style({
                image: new Icon({
                  src: markersStyle[gridTypeId],
                }),
              });
            }
          } else {
            if (view.getZoom() > 11) {
              return new Style({
                image: new CircleStyle({
                  radius: 3,
                  fill: new Fill({ color: "red" }),
                  stroke: new Stroke({
                    color: [255, 0, 0],
                    width: 2,
                  }),
                }),
              });
            } else {
              return new Style();
            }
          }
        }
        if (isDuplicate && view.getZoom() > 11) {
          return new Style({
            image: new Icon({
              src:
                selected && selectedFeature.length && selectedId
                  ? markersStyleSelected[gridTypeId]
                  : markersStyle[gridTypeId],
            }),
            text: new Text({
              stroke: new Stroke({
                color: "#FFF",
                width: 8,
              }),
              offsetX: 6,
              offsetY: -12,
              padding: [2, 4, 1, 4],
              textAlign: "right",
              font: "bold 10px san-serif",
              text: size.toString(),
              fill: new Fill({
                color: "#000",
              }),
            }),
          });
        }
        if (isDuplicateTypeGrid) {
          if (view.getZoom() > 9.9) {
            return new Style({
              zIndex: 2,
              image: new CircleStyle({
                radius: Math.min(size + 12, 18),
                stroke: new Stroke({
                  width: 2,
                  color: colorsIdx[gridTypeId] ?? "red",
                }),
                fill: new Fill({
                  color: colorsIdx[gridTypeId] ?? "red",
                }),
              }),
              text: new Text({
                stroke: new Stroke({
                  color: "#FFF",
                  width: 4,
                }),
                fill: new Fill({
                  color: "black",
                }),
                text: size.toString(),
                font: "12px bold Calibri,sans-serif",
                offsetY: 1,
              }),
            });
          }
        }
      };

      const clustersArray = arrayId.map((id, idx) => {
        return new Cluster({
          source: source,
          geometryFunction: function (feature) {
            if (
              view.getZoom() <= 9.9 &&
              feature.get("name").districtId === id
            ) {
              return feature.getGeometry();
            }
            if (
              view.getZoom() > 9.9 &&
              feature.get("name").gridTypeId === gridArrId[idx]
            ) {
              return feature.getGeometry();
            }
          },
        });
      });

      const districtsLayersArray = Districts.ArrayDistrictsLayers.map(
        (layers) => {
          return new VectorLayer({
            source: new VectorSource({
              url: layers.url,
              format: new KML(),
            }),
            visible: true,
            opacity: 1,
          });
        },
      );

      const animatedClusters = clustersArray.map((item) => {
        item?.setDistance(30000);
        return new AnimatedCluster({
          source: item,
          animationDuration: 300,
          style: styleCluster,
        });
      });
      window.document
        .querySelectorAll(".ol-zoom.ol-unselectable.ol-control")
        .forEach((item) => item.remove());

      map = new Map({
        controls: [new Zoom({ target: "select-layers", delta: 0.5 })],
        layers: [...tileLayers, ...districtsLayersArray, ...animatedClusters],
        target: "map",
        view: view,
      });

      const overLayer = new Overlay({
        element: popupRef.current,
      });
      map.addOverlay(overLayer);

      window.document.querySelectorAll(".ant-table-cell a").forEach((a) => {
        a.addEventListener("click", () => {
          selected = false;
          const centerMarker = marker.filter(
            (mark) => mark.get("name")?.id == a.textContent,
          );
          selectedId = centerMarker[0].get("name")?.id;
          selected = true;
          selectedCluster = true;
          view.animate({
            zoom: 15.5,
            center: [
              centerMarker[0].getGeometry()?.flatCoordinates[0] + 1,
              centerMarker[0].getGeometry()?.flatCoordinates[1],
            ],
            duration: 900,
          });
        });
      });

      window.document.addEventListener("click", () => {
        refPosition.current = [view.getZoom(), view.getCenter()];
      });

      // DefectRegister.siderCollapsed
      //   ? view.animate({
      //       zoom: refPosition.current[0][0],
      //       center: [3339250.2539037718, 8368154.581258831],
      //       duration: 900,
      //     })
      //   : null;
      map.on("moveend", function (e) {
        const zoom = map.getView().getZoom(); // Получить уровень масштабирования текущей карты
        if (zoom > 9.9) {
          clustersArray.map((item) => {
            return zoom > 14 ? item?.setDistance(0) : item?.setDistance(30);
          });
        } else {
          clustersArray.map((item) => {
            return item?.setDistance(30000);
          });
        }
      });
      map.on("click", function (e) {
        selectedCluster = true;
        overLayer.setPosition(undefined);
        map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
          const features = feature.get("features");
          if (!features || features.some((f) => !f.get("name")?.gridTypeId))
            return;

          features.sort(function (a, b) {
            return (
              new Date(b?.values_?.name?.dateTimeDisable) -
              new Date(a?.values_?.name?.dateTimeDisable)
            );
          });
          console.log(e);
          const clickedCoord = e.coordinate;
          selected = false;
          try {
            selectedId = features[0].get("name")?.id;
          } catch (e) {
            console.log(e);
          }
          selected = true;
          const header =
            document.getElementsByClassName("ant-layout-header")[0];
          const footer =
            document.getElementsByClassName("ant-layout-footer")[0];
          const aside = document.getElementsByClassName("ant-layout-sider")[1];

          view.padding[0] = header?.offsetHeight;
          view.padding[2] = footer?.offsetHeight;
          view.padding[3] = aside?.offsetWidth;

          view.animate({
            center: clickedCoord,
            duration: 900,
          });

          const isDuplicate = features?.every(
            (val, i, arr) =>
              val.get("name").gridType?.id === arr[0].get("name").gridType?.id,
          );
          const isDuplicateAddress = features?.every(
            (val, i, arr) =>
              val.get("name").lat === arr[0].get("name").lat &&
              val.get("name").lng === arr[0].get("name").lng,
          );
          overLayer.setPosition(clickedCoord);
          if (
            isDuplicateAddress &&
            view.getZoom() !== 9.9 &&
            popupRef.current
          ) {
            popupRef.current.innerHTML = `<table class="table-popup">
                    <span class="table-popup__close-icon">
                                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99891 6.58681L3.41661 2.00452L2.0024 3.41873L6.5847 8.00103L2.00216 12.5836L3.41637 13.9978L7.99891 9.41524L12.5815 13.9978L13.9957 12.5836L9.41312 8.00103L13.9954 3.41873L12.5812 2.00452L7.99891 6.58681Z" fill="#6D8991"/>
                                                          </svg>
                                                          </span>
                                                            <h3 class="table-title">${
                                                              features[0].get(
                                                                "name",
                                                              ).addressText
                                                            } </h3>
                                                            <thead>
                                                            <th>Организация</th>
                                                            <th>Зданий отключено</th>
                                                            <th>Дата отключения</th>
                                                            <th style="white-space: nowrap;">Просрочено, ч</th>
                                                            <th></th>
                                                            </thead>
                                                            <tbody>

                                                            </tbody>
                                                        </table>`;
          }

          if (
            isDuplicate &&
            !isDuplicateAddress &&
            features.length > 1 &&
            view.getZoom() > 9.9
          ) {
            overLayer.setPosition(undefined);
            selectedCluster = false;
            view.animate({
              center: clickedCoord,
              duration: 900,
              zoom: 14.7,
            });
          }
          const tableBody = document.querySelector(".table-popup tbody");

          function arrayUnique(arr) {
            return arr.filter((e, i, a) => a.indexOf(e) == i);
          }

          const uniqGridType = arrayUnique(
            features.map((item) => {
              return item.get("name").gridType?.id;
            }),
          );
          const uniqGridTitle = arrayUnique(
            features.map((item) => {
              return item.get("name").gridType?.title;
            }),
          );
          const arrUniq = uniqGridTitle.map((item, idx = 1) => {
            return {
              title: item,
              id: uniqGridType[idx],
            };
          });
          if (isDuplicate && view.getZoom() <= 9.9) {
            window.document.querySelectorAll(".ol-popup").forEach((item) => {
              item.classList.remove("card-map");
            });
            if (popupRef.current) {
              popupRef.current.innerHTML = `<div class="cluster-card">
                                 <h3>
                                     ${
                                       features[0].get("name").district.title
                                     } район
                                </h3>
                                <ul class="cluster-card__list">

              </ul>
              </div>`;

              arrUniq.forEach((item) => {
                const clusterList = document.querySelector(
                  ".cluster-card__list",
                );
                const li = clusterList.appendChild(
                  document.createElement("li"),
                );
                li.innerHTML = `<div class="cluster-card__item">
                                <div class="cluster-card__left">
                                <img src="${markersStyle[item.id]}"/>
                                <h4>${item.title}</h4></div>
                                <div>${
                                  features.filter(
                                    (f) =>
                                      f.get("name").gridType.id === item.id,
                                  ).length
                                }</div></div>`;
              });
            }
          }
          if (!isDuplicate) {
            if (popupRef.current) {
              popupRef.current.innerHTML = `<div class="cluster-card">
                                 <h3>
                                     ${
                                       features[0].get("name").district.title
                                     } район
                                </h3>
                                <ul class="cluster-card__list">

            </ul>
            </div>`;
            }
            if (features.length > 1) {
              selected = false;
              selectedId = null;
            }
            popupRef.current?.classList.remove("ol-popup--dublicate");
            window.document.querySelectorAll(".ol-popup").forEach((item) => {
              item.classList.remove("card-map");
            });
            arrUniq.forEach((item) => {
              const clusterList = document.querySelector(".cluster-card__list");
              const li = clusterList.appendChild(document.createElement("li"));
              li.innerHTML = `<div class="cluster-card__item">
                              <div class="cluster-card__left">
                              <img src="${markersStyle[item.id]}"/>
                              <h4>${item.title}</h4>
</div>
                              <div>${
                                features.filter(
                                  (f) => f.get("name").gridType.id === item.id,
                                ).length
                              }</div>
</div>`;
            });
          }
          if (isDuplicate) {
            popupRef.current?.classList.add("ol-popup--dublicate");
            if (features.length > 1) {
              selected = false;
              selectedId = null;
            }
            features.forEach((item) => {
              if (isDuplicateAddress && features.length > 1) {
                selected = true;
                selectedId = item.get("name")?.id;
                document.querySelector(".table-title").textContent =
                  item.get("name").addressText;
              }
              if (!isDuplicateAddress) {
                selected = true;
                selectedId = item.get("name")?.id;
                document.querySelector(".table-title").textContent =
                  features.length == 1 ? item.get("name").addressText : "";
              }

              if (tableBody) {
                const tr = tableBody.appendChild(document.createElement("tr"));

                tr.innerHTML = `
                      <td>${item.get("name")?.organization?.name}</td>
                      <td>${item.get("name")?.overBuildings || 0}</td>
                      <td>${M(item.get("name")?.dateTimeDisable).format(
                        Constants.dateTimeFormat,
                      )}</td>
                      <td>${
                        item.get("name")?.overdueTime
                          ? item.get("name").overdueTime
                          : ""
                      }</td>
                      <td><a id="openCard" title="Открыть карточку дефекта">
                      <svg class="map-open-card" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22 9V3C22 2.44772 21.5523 2 21 2H15V4H18.5858L9.29289 13.2929L10.7071 14.7071L20 5.41421V9H22ZM2 5C2 3.89543 2.89543 3 4 3H11.5V5H4V20H19V12.5H21V20C21 21.1046 20.1046 22 19 22H4C2.89543 22 2 21.1046 2 20V5Z" fill="#BACAD0"/>
                                </svg>
                                </a></td>`;
              }

              // Выносим данные на верх
              const closeEl = window.document.querySelector(
                ".table-popup__close-icon",
              );
              if (closeEl) {
                closeEl.addEventListener("click", () => {
                  overLayer.setPosition(undefined);
                });
              }

              function openCards() {
                popupRef.current?.classList.add("card-map");
                openCardBtn.current = item.get("name");
                console.log(openCardBtn.current, "openCardBtn.current");
                popupRef.current?.removeChild(
                  document.querySelector(".table-popup"),
                );
                document.querySelector(".table-title").textContent =
                  openCardBtn?.current?.addressText;
                const ul = popupRef.current?.appendChild(
                  document.createElement("ul"),
                );

                ul.innerHTML = `
                                        <li>
                                        <p>Эксплуатирующая организация</p>
                                        <div class='map-card-text'>${
                                          openCardBtn?.current?.organization
                                            ?.name
                                        }</div>
                                        </li>
                                        <li>
                                        <p>Зданий всего</p>
                                        <div class='map-card-text'>${
                                          openCardBtn?.current?.overBuildings ||
                                          0
                                        }</div>
                                        <p>Количество отключенных абонентов</p>
                                        <div class='map-card-text'>${
                                          openCardBtn?.current
                                            ?.disconnectedSubscribers || 0
                                        }</div>                                        
                                        </li>
                                        <li>
                                        <p>Дата отключения</p>
                                        <div class='map-card-text'>${
                                          openCardBtn?.current?.dateTimeDisable
                                            ? M(
                                                openCardBtn.current
                                                  .dateTimeDisable,
                                              ).format(Constants.dateTimeFormat)
                                            : Constants.notSet
                                        } </div>
                                        <p>Превышение сроков устранения, ч</p>
                                        <div class='map-card-red-text'>${
                                          openCardBtn?.current?.overdueTime
                                            ? openCardBtn.current.overdueTime
                                            : "-"
                                        }</div>
                                        </li>
                                        <li><button class="openCard-btn">${
                                          openCardBtn?.current?.key ?? ""
                                        }&#9;&#9;Открыть полную карточку</button></li>
                                        `;
                window.document
                  .querySelectorAll(".openCard-btn")
                  .forEach((btn) => {
                    btn.addEventListener("click", () => {
                      selected = true;
                      selectedId = item.get("name")?.id;
                      DefectRegister.openDefect(item.get("name").id);
                      overLayer.setPosition(undefined);
                      popupRef.current?.classList.remove("card-map");
                    });
                  });
              }

              if (features.length == 1 && view.getZoom() !== 9.9) {
                openCards();
              }

              window.document
                .querySelectorAll("#openCard")
                .forEach((popup, i, array) => {
                  popup.addEventListener("click", () => openCards());
                });
            });
          }
        });
      });
      window.document.querySelectorAll(".notice__popup").forEach((itemN) => {
        itemN.addEventListener("click", (e) => {
          overLayer.setPosition(undefined);
          // DefectRegister.clearFilters();
          // DefectRegister.getRegistry();
          selectedCluster = true;
          const id = itemN.getAttribute("data-id");
          selected = true;
          selectedId = id;
          const getNoties = marker.filter(
            (item) => item.values_?.name.id == id,
          );
          view.animate({
            zoom: 15.5,
            center: getNoties[0]?.getGeometry()?.flatCoordinates,
            duration: 900,
          });
          if (popupRef.current) {
            popupRef.current.innerHTML = `<table class="table-popup">
                      <span class="table-popup__close-icon">
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99891 6.58681L3.41661 2.00452L2.0024 3.41873L6.5847 8.00103L2.00216 12.5836L3.41637 13.9978L7.99891 9.41524L12.5815 13.9978L13.9957 12.5836L9.41312 8.00103L13.9954 3.41873L12.5812 2.00452L7.99891 6.58681Z" fill="#6D8991"/>
                                                            </svg>
                                                            </span>
                                                              <h3 class="table-title">${getNoties[0]?.values_?.name?.addressText}</h3>
                                                          </table>`;
          }
          popupRef.current?.classList.add("card-map");
          overLayer.setPosition(getNoties[0]?.getGeometry()?.flatCoordinates);

          const ul = popupRef.current?.appendChild(
            document.createElement("ul"),
          );

          ul.innerHTML = `
                                        <li>
                                        <p>Эксплуатирующая организация</p>
                                        <div class='map-card-text'>${
                                          getNoties[0]?.values_?.name
                                            ?.organization?.name
                                        }</div>
                                        </li>
                                        <li>
                                        <p>Зданий всего</p>
                                        <div class='map-card-text'>${
                                          getNoties[0]?.values_?.name
                                            ?.overBuildings || 0
                                        }</div>
                                        <p>Количество отключенных абонентов</p>
                                        <div class='map-card-text'>${
                                          getNoties[0]?.values_?.name
                                            ?.disconnectedSubscribers || 0
                                        }</div>
                                        </li>
                                        <li>
                                        <p>Дата отключения</p>
                                        <div class='map-card-text'>${M(
                                          getNoties[0]?.values_?.name
                                            .dateTimeDisable,
                                        ).format(
                                          Constants.dateTimeFormat,
                                        )} </div>
                                        <p>Превышение сроков устранения, ч</p>
                                        <div class='map-card-red-text'>${
                                          getNoties[0]?.values_?.name
                                            .overdueTime
                                            ? getNoties[0].values_.name
                                                .overdueTime
                                            : "-"
                                        }</div>
                                        </li>
                                        <li><button class="openCard-btn">${
                                          getNoties[0]?.values_?.name?.key ?? ""
                                        }&#9;&#9;Открыть полную карточку</button></li>`;
          window.document.querySelectorAll(".openCard-btn").forEach((btn) => {
            btn.addEventListener("click", () => {
              DefectRegister.openDefect(notiesId?.current);
              overLayer.setPosition(undefined);
              popupRef.current?.classList.remove("card-map");
              // popupRef.current?.classList.remove("card-map");
            });
          });
          window.document
            .querySelector(".table-popup__close-icon")
            .addEventListener("click", () => {
              overLayer.setPosition(undefined);
            });
        });
      });
    };

    fetch(urlMap.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        text = text.replace(/http:\/\/gis.toris/g, "https://gis.toris");
        const result = parser.read(text);
        const options = optionsFromCapabilities(result, {
          layer: urlMap.name,
          matrixSet: "EPSG::202474", //"EPSG:4326"
          projection: projection,
        });

        const tileLayers = [
          new TileLayer({
            source: new OSM(),
            opacity: 1,
          }),
          new TileLayer({
            opacity: mapOsm === "default" ? 0 : 1,
            source: new WMTS(options),
          }),
        ];
        loadMarkers(tileLayers);
      })
      .catch(() => {
        window.document
          .querySelectorAll(".ol-viewport")
          .forEach((item) => item.remove());

        const tileLayer = new TileLayer({
          source: new OSM(),
          opacity: 1,
        });
        loadMarkers([tileLayer]);
      });
  }

  const menu = (
    <Radio.Group
      className="select-layers-wrapper"
      onChange={handlerSelectMap}
      value={mapOsm}
    >
      <Space direction="vertical">
        {/* <Radio value={"default"}>Стандартная</Radio> */}
        <Radio value={"BASE_MAP"}>Цветная ТОРИС</Radio>
        <Radio value={"BM_MSK_GRAY"}>Монохромная</Radio>
        <Radio value={"ORTOPHOTO_2016"}>Ортофотоплан</Radio>
      </Space>
    </Radio.Group>
  );

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.innerText = `
    var elmnt = document.getElementById("popup");
    console.log(elmnt, '---------------elmnt');
    dragElement(elmnt);
    function dragElement(elm) {
      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      elm.onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;

        document.onmousemove = elementDrag;      
      }

      function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;      
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();

        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;

        elm.style.top = (elm.offsetTop - pos2) + "px";
        elm.style.left = (elm.offsetLeft - pos1) + "px";      
      }
    }
    

    `;
    //document.body.appendChild(script1);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      //document.body.removeChild(script1);
    };
  }, []);

  return (
    <div>
      <div id="map" ref={mapRef}>
        <Search
          value={DefectRegister.initialFilter.Address}
          onChange={onAddressSearch}
        />
        <div className={styles.spinnerMap}>
          <Spin
            size={"large"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </div>
        <div ref={popupRef} id="popup" className="ol-popup"></div>
        <div className="select-layers" id="select-layers">
          <Dropdown overlay={menu} placement="bottomLeft" arrow>
            <div className="map-control-ico">
              <MapControlIco />
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
});

export default Map2;
